module.exports = __webpack_public_path__ + "img/contacto.cbf8e38c.png";